<template>
  <div class="selectBox flex-fJcenter-fAcenter">
    <v-select
      @input="executeNavigation($event, 1)"
      :placeholder="labelNameLevel1"
      :components="{Deselect, OpenIndicator}"
      :options="menusNiv1"
      label="LIBELLE"
      v-model="fieldsData[0]"
    >
      <div
        slot="no-options"
        v-html="labelNameNoResult"
      />
    </v-select>
    <v-select
      @input="executeNavigation($event, 2)"
      :placeholder="labelNameLevel2"
      :components="{Deselect, OpenIndicator}"
      :options="menusNiv2"
      label="LIBELLE"
      v-model="fieldsData[1]"
    >
      <div
        slot="no-options"
        v-html="labelNameNoResult"
      />
    </v-select>
    <v-select
      v-if="nivMax >= 3"
      @input="executeNavigation($event, 3)"
      :placeholder="labelNameLevel3"
      :components="{Deselect, OpenIndicator}"
      :options="menusNiv3"
      label="LIBELLE"
      v-model="fieldsData[2]"
    >
      <div
        slot="no-options"
        v-html="labelNameNoResult"
      />
    </v-select>
    <v-select
      v-if="nivMax >= 4"
      @input="executeNavigation($event, 4)"
      :placeholder="labelNameLevel4"
      :components="{Deselect, OpenIndicator}"
      :options="menusNiv4"
      label="LIBELLE"
      v-model="fieldsData[3]"
    >
      <div
        slot="no-options"
        v-html="labelNameNoResult"
      />
    </v-select>
    <v-select
      v-if="nivMax >= 5"
      :placeholder="labelNameLevel5"
      :components="{Deselect, OpenIndicator}"
      :options="menusNiv5"
      label="LIBELLE"
      v-model="fieldsData[4]"
    >
      <div
        slot="no-options"
        v-html="labelNameNoResult"
      />
    </v-select>
    <p class="flex-fJcenter-fAcenter">
      <a
        class="buttonIcon icon-zoom"
        :href="this.categoryLink"
      >
        {{ labelNameButton }}
      </a>
    </p>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from 'axios'

export default {
  components: {
    'v-select': vSelect
  },
  props: {
    'labelNameLevel1': {
      type: String,
      required: true
    },
    'labelNameLevel2': {
      type: String,
      required: true
    },
    'labelNameLevel3': {
      type: String,
      required: true
    },
    'labelNameLevel4': {
      type: String,
      required: true
    },
    'labelNameLevel5': {
      type: String,
      required: true
    },
    'labelNameButton': {
      type: String,
      required: true
    },
    'labelNameNoResult': {
      type: String,
      required: true
    },
    'labelNameDeselect': {
      type: String,
      required: true
    },
    'menusNiv1': {
      type: Array,
      default() {
        return []
      }
    },
    'nivMax': {
      type: Number,
      required: true,
      validator(value) {
        return value >= 1
      }
    },
    'fieldsInit': {
      type: Array,
      default() {
        return []
      }
    }
  },
  data: function () {
    return {
      menusNiv2: [],
      menusNiv3: [],
      menusNiv4: [],
      menusNiv5: [],
      categoryLink: '',
      OpenIndicator: {
        render: createElement => createElement('span', {
          class: {
            'icon-arrowdown': true
          }
        })
      },
      Deselect: {
        render: createElement => createElement('span', {
          class: {
            'icon-cross': true
          },
          attrs: {
            title: 'Vider la sélection'
          }
        })
      },
      fieldsData: []
    }
  },
  async created() {
    this['fieldsData'] = this['fieldsInit']
    //précharge le premier niveau
    if (this['fieldsData'][0] !== undefined) {
      await this.getSubMenu(this['fieldsData'][0])
    }
  },
  async mounted() {
    //précharge les listes des select qui peuvent l'être
    for (let i = 1; i < 5; i++) {
      if (this['fieldsData'][i] !== undefined) {
        await this.getSubMenu(this['fieldsData'][i])
      } else {
        break
      }
    }
  },
  methods: {
    async getSubMenu(val) {
      const code = val.CODE
      const level = parseInt(val.NIVEAU) + 1
      this.categoryLink = val.LIEN
      await this.fetch(code).then((response) => {
        this['menusNiv' + level] = response
      }, (response) => console.log('getSubMenu niv' + level + ' Error : ' + JSON.stringify(response)))
    },
    async fetch(activite) {
      const response = await axios.get('/simplemenu/' + activite).catch(e => {
        throw new Error('error getting menu', e)
      })
      return response.data
    },
    supprNiveauSup(level) {
      for (let i = level; i < 5; i++) {
        this['fieldsData'][i] = null
        this['menusNiv' + (i+1)] = []
      }
    },
    async executeNavigation(val, nivSupression) {
      this.supprNiveauSup(nivSupression)
      if (val !== undefined && val !== null) {
        this.getSubMenu(val)
      }else {
        //Cas d'une suppression : le lien doit être valorisé au niveau supérieur
        this.categoryLink = this['fieldsData'][nivSupression-2]['LIEN']
      }
    }
  }
}
</script>
